import { Box, Link } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import Text from "src/components/Text"
import { GET_VENO_APR } from "src/constants/queryKeys"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import { useQuery } from "@tanstack/react-query"

interface Props {
  content: string
  mt?: number
  mb?: number
  link?: string
}

const CroWarning = ({
  content,
  mt = 2,
  mb = 0,
  link = "https://docs.ferroprotocol.com/getting-started/ferro-tokens",
}: Props) => {
  const { t } = useTranslation()

  return (
    <Box
      alignItems="center"
      borderRadius="12px"
      bgcolor="rgba(0, 155, 224, 0.4)"
      p="14px 12px"
      mt={mt}
      mb={mb}
      display="flex"
    >
      <ErrorOutlineIcon />
      <Text ml="6px" lineHeight={1.5} fontSize="14px">
        <>
          {t(content)}{" "}
          {link && (
            <Link
              color="#fff"
              fontWeight="bold"
              target="_blank"
              href={link}
              rel="nofollow"
            >
              {t("Learn more")}
            </Link>
          )}
        </>
      </Text>
    </Box>
  )
}

export const CommonWarning = ({
  content,
  mt = 0,
  mb = 0,
  link = "",
}: Props) => {
  return <CroWarning content={content} mt={mt} mb={mb} link={link} />
}

export const CroPoolWarning = ({ mt, mb }: Partial<Props>) => {
  const GET_VENO_APR_API = process.env.REACT_APP_VENO_APR_FERRO!
  const { data } = useQuery(
    [GET_VENO_APR],
    () =>
      fetch(`${GET_VENO_APR_API}`, { cache: "no-cache" }).then((res) => {
        if (res.status >= 200 && res.status < 300) {
          return res.json() as Partial<{ value: number }>
        }
        throw new Error("Unable to call getVenoApr")
      }),
    {
      enabled: !!GET_VENO_APR_API,
    },
  )
  const aprMsg =
    data?.value && data?.value > 0
      ? ` up to ${(data.value * 100).toFixed(2)}%`
      : ""
  const message = `You can now stake your LP tokens at Veno Finance to earn VNO rewards${aprMsg}!`
  const link =
    "https://docs.ferroprotocol.com/user-guides/ferro-pools/our-partners#we-are-moving-the-rewards-emissions-for-staked-lp-to-veno-finance"
  return <CroWarning content={message} mt={mt} mb={mb} link={link} />
}

export default CroWarning
